import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

const SAVE_DIETS_AND_DIET_CATEGORIES_MUTATION = gql`
  mutation saveDietsAndDietCategories($data: [DietCategoryNodeInput!]!) {
    saveDietsAndDietCategories(data: $data) {
      results {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
        type
        children {
          id
          name
          isCurationEnabled
          level
          idPath
          namePath
          type
          parentId
        }
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
`

export default SAVE_DIETS_AND_DIET_CATEGORIES_MUTATION
